import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/format-message';
import { withI18nSupport } from '@instructure/quiz-common';
export var ElapsedTime = /*#__PURE__*/function (_withI18nSupport) {
  function ElapsedTime() {
    _classCallCheck(this, ElapsedTime);
    return _callSuper(this, ElapsedTime, arguments);
  }
  _inherits(ElapsedTime, _withI18nSupport);
  return _createClass(ElapsedTime, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        eventTime = _this$props.eventTime,
        startTime = _this$props.startTime;
      var difference = eventTime - startTime;
      var totalSeconds = difference / 1000;
      var hours = Math.floor(totalSeconds / 3600);
      var remainder = totalSeconds - hours * 3600;
      var minutes = Math.floor(remainder / 60);
      var seconds = remainder - minutes * 60;

      // Intl.DurationFormat doesn't exist yet.
      // https://github.com/tc39/ecma402/issues/47
      // Let translators provide patterns for durations
      var displayTime = hours ? t('{hours}:{minutes}:{seconds}', {
        hours: this.formatDecimal2MinIntegerNoFraction(hours),
        minutes: this.formatDecimal2MinIntegerNoFraction(minutes),
        seconds: this.formatDecimal2MinIntegerNoFraction(seconds)
      }) : t('{minutes}:{seconds}', {
        minutes: this.formatDecimal2MinIntegerNoFraction(minutes),
        seconds: this.formatDecimal2MinIntegerNoFraction(seconds)
      });
      return /*#__PURE__*/React.createElement("span", null, displayTime);
    }
  }]);
}(withI18nSupport(Component));
_defineProperty(ElapsedTime, "propTypes", {
  eventTime: PropTypes.instanceOf(Date).isRequired,
  startTime: PropTypes.instanceOf(Date).isRequired,
  locale: PropTypes.string
});
_defineProperty(ElapsedTime, "defaultProps", {
  locale: null
});
_defineProperty(ElapsedTime, "contextTypes", {
  locale: PropTypes.string
});
export default ElapsedTime;